import { render, staticRenderFns } from "./FileUploadPWP_zl.vue?vue&type=template&id=3610d19a&scoped=true&"
import script from "./FileUploadPWP_zl.vue?vue&type=script&lang=js&"
export * from "./FileUploadPWP_zl.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadPWP_zl.vue?vue&type=style&index=0&id=3610d19a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3610d19a",
  null
  
)

export default component.exports